import { FlowItem, IIdItem } from './resourceParts';

export type FlowRun = FlowItem & IIdItem & {
  readonly startedAt: string; // YYYY-MM-DDThh:mm:ssZ
  readonly completedAt: string; // YYYY-MM-DDThh:mm:ssZ
  readonly status: string; // [ PENDING, INPROGRESS, SUCCESS, FAILED, CANCELLED ]
  readonly taskId: string;
  readonly triggerType: FlowRunTriggerType;
  readonly errorMessage: string;
  readonly outputStepIds: ReadonlyArray<string>;
  readonly outputStepRunIds: ReadonlyArray<string>;
};

export enum FlowRunTriggerType {
  adhoc = 'AdHoc',
  scheduled = 'Scheduled',
}
